<template>
  <a-flex gap="middle" justify="center">
    <a-tooltip :title="'Создать копию этикетки'">
      <router-link
        :to="{
          name: 'labelsEdit',
          params: { labelId: 'create' },
          query: { cloneId: label.label.id },
        }"
      >
        <a-button
          :disabled="isLabelUpdating"
          :icon="h(CopyOutlined)"
          class="icon-button clone"
        />
      </router-link>
    </a-tooltip>

    <a-tooltip
      v-if="labelTemplateStore.isAdminAccount"
      :title="'Редактировать этикетку'"
    >
      <router-link
        :to="{
          name: 'labelsEdit',
          params: { labelId: label.label.id },
          query: { isCommon: 'true' },
        }"
      >
        <a-button
          :disabled="isLabelUpdating"
          :icon="h(EditOutlined)"
          class="icon-button"
        />
      </router-link>
    </a-tooltip>

    <a-tooltip
      v-if="labelTemplateStore.isAdminAccount"
      :title="'Удалить этикетку'"
    >
      <a-button
        :disabled="isLabelUpdating"
        danger
        @click="deleteLabel()"
        :icon="h(DeleteOutlined)"
        class="icon-button delete"
      />
    </a-tooltip>
  </a-flex>
</template>

<script setup lang="ts">
import {
  type LabelTemplateTableData,
  useLabelTemplateStore,
} from "@/stores/labelTemplate/labelTemplateStore";
import { computed, h } from "vue";
import {
  DeleteOutlined,
  EditOutlined,
  CopyOutlined,
} from "@ant-design/icons-vue";
import { showConfirm } from "@/tools/ConfirmationDialog";

const props = defineProps<{ label: LabelTemplateTableData }>();

const labelTemplateStore = useLabelTemplateStore();

const isLabelUpdating = computed(() =>
  labelTemplateStore.processingCommonLabels.has(props.label.label.id),
);

const deleteLabel = () => {
  showConfirm({
    title: `Вы действительно хотите удалить шаблон "${props.label.labelTemplateName}"? Изменения не обратимы!`,
    onOk: async () => {
      await labelTemplateStore.deleteCommonLabelTemplates([
        props.label.label.id,
      ]);
    },
  });
};
</script>

<style scoped lang="scss">
.icon-button {
  padding: 0;
  font-size: 20px;
  line-height: 1;
  background: none;
  border: none;
  box-shadow: none;
}
.delete:hover {
  color: #ff5226;
}
.clone:hover {
  color: #0f884c;
}
</style>
